<template>
  <v-tooltip
    max-width="345"
    transition="tooltip-transition"
    :top="topPosition"
    :bottom="bottom"
    :left="left"
    :right="right"
    :content-class="tooltipClass"
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        v-bind="attrs"
        :style="tooltipStyle"
        :class="containerClass"
        v-on="!!$slots.default && on"
      >
        <slot name="element">
          <div class="flex-centering">
            <Icon class="pointer" type="info-circle" color="secondary" size="18" />
          </div>
        </slot>
      </div>
    </template>
    <div v-if="$slots.default">
      <slot />
    </div>
  </v-tooltip>
</template>

<script>
  import { VTooltip } from 'vuetify/lib';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'Tooltip',
    components: {
      VTooltip,
      Icon,
    },
    props: {
      bottom: {
        type: Boolean,
        default: false,
      },
      top: {
        type: Boolean,
        default: false,
      },
      right: {
        type: Boolean,
        default: false,
      },
      left: {
        type: Boolean,
        default: false,
      },
      small: {
        type: Boolean,
        default: false,
      },
      containerClass: String,
    },
    computed: {
      tooltipStyle() {
        return { cursor: this.$slots.default ? 'pointer' : 'auto', width: 'inherit' };
      },
      tooltipClass() {
        return `${this.small ? 'small' : ''}`;
      },
      topPosition() {
        return this.top || (!this.bottom && !this.left && !this.right);
      },
    },
  };
</script>
